import React from "react";
import loader from "../assets/svg/loader.svg"

const PageLoader = () => {
  return (
   <div id="global-loader">
  <img src={loader} className="loader-img" />
</div>

  );
};

export default PageLoader;
